import { fetchClientJSON } from '../../../services/clientDataService';

/** Files live under {UPLOADS_BASE_URL}/api/browse/analysis/{client}/{file}. */
export const ANALYSIS_UPLOADS_PROJECT = 'analysis';
export const ANALYSIS_DEFAULT_CLIENT = 'default';

export const ANALYSIS_FILES = {
  geojson: 'od_map.json',
  percentages: 'data_percentages.json',
  config: 'config.json',
};

const fetchAnalysisJSON = (clientType, file) =>
  fetchClientJSON(clientType, file, { project: ANALYSIS_UPLOADS_PROJECT, trackLoading: false });

const loadClient = async (clientType) => {
  const [geojson, percentages, config] = await Promise.all([
    fetchAnalysisJSON(clientType, ANALYSIS_FILES.geojson),
    fetchAnalysisJSON(clientType, ANALYSIS_FILES.percentages),
    fetchAnalysisJSON(clientType, ANALYSIS_FILES.config),
  ]);
  return { geojson, percentages, config, clientType };
};

/** The datasets reach tens of MB, so each client is parsed once per session. */
const datasetCache = new Map();

export const clearAnalysisDatasetCache = () => datasetCache.clear();

/**
 * Load the OD dataset of a client, falling back to the default folder when the
 * client has no Analysis data of its own.
 */
export function loadAnalysisDataset(clientType) {
  const client = clientType || ANALYSIS_DEFAULT_CLIENT;
  if (!datasetCache.has(client)) {
    const promise = loadClient(client).catch((err) => {
      if (client === ANALYSIS_DEFAULT_CLIENT) throw err;
      console.warn(`[Analysis] No data for "${client}", using "${ANALYSIS_DEFAULT_CLIENT}":`, err.message);
      return loadClient(ANALYSIS_DEFAULT_CLIENT);
    });
    promise.catch(() => datasetCache.delete(client));
    datasetCache.set(client, promise);
  }
  return datasetCache.get(client);
}
